import { c as _ } from "./_commonjsHelpers-BVfed4GL.js";
var o = {}, E = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 }), i.CHAIN_CHANGED = i.PROVIDER_CHANGED = i.ADDRESS_CHANGED = i.MANIFOLD_ETHEREUM_EXISTS = i.MANIFOLD_ETHEREUM_INITIALIZED = i.EthereumProviderErrorName = void 0, function(n) {
    n.EthereumProviderMultipleChains = "EthereumProviderMultipleChains", n.WindowEthereumConnectionError = "WindowEthereumConnectionError";
  }(i.EthereumProviderErrorName || (i.EthereumProviderErrorName = {})), i.MANIFOLD_ETHEREUM_INITIALIZED = "manifold-ethereum-initialized", i.MANIFOLD_ETHEREUM_EXISTS = "manifold-ethereum-exists", i.ADDRESS_CHANGED = "ethereum-address-changed", i.PROVIDER_CHANGED = "frontend-provider-changed", i.CHAIN_CHANGED = "frontend-provider-chain-changed";
})(E);
var t = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 }), i.EthereumNetwork = void 0, function(n) {
    n[n.MAINNET = 1] = "MAINNET", n[n.GOERLI = 5] = "GOERLI", n[n.OPTIMISM = 10] = "OPTIMISM", n[n.BSC = 56] = "BSC", n[n.MATIC = 137] = "MATIC", n[n.OPTIMISM_GOERLI = 420] = "OPTIMISM_GOERLI", n[n.BASE = 8453] = "BASE", n[n.ARBITRUM = 42161] = "ARBITRUM", n[n.AVALANCHE_FUJI = 43113] = "AVALANCHE_FUJI", n[n.AVALANCHE = 43114] = "AVALANCHE", n[n.ARBITRUM_GOERLI = 421613] = "ARBITRUM_GOERLI", n[n.MUMBAI = 80001] = "MUMBAI", n[n.BASE_GOERLI = 84531] = "BASE_GOERLI", n[n.SEPOLIA = 11155111] = "SEPOLIA";
  }(i.EthereumNetwork || (i.EthereumNetwork = {}));
})(t);
var f = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 }), i.OAuthGrantType = void 0, function(n) {
    n.TOKEN = "token", n.SIGNATURE = "signature", n.SIWE = "siwe";
  }(i.OAuthGrantType || (i.OAuthGrantType = {}));
})(f);
(function(i) {
  var n = _ && _.__createBinding || (Object.create ? function(a, e, d, A) {
    A === void 0 && (A = d);
    var I = Object.getOwnPropertyDescriptor(e, d);
    (!I || ("get" in I ? !e.__esModule : I.writable || I.configurable)) && (I = { enumerable: !0, get: function() {
      return e[d];
    } }), Object.defineProperty(a, A, I);
  } : function(a, e, d, A) {
    A === void 0 && (A = d), a[A] = e[d];
  }), c = _ && _.__exportStar || function(a, e) {
    for (var d in a) d !== "default" && !Object.prototype.hasOwnProperty.call(e, d) && n(e, a, d);
  };
  Object.defineProperty(i, "__esModule", { value: !0 }), c(E, i), c(t, i), c(f, i);
})(o);
function r(i) {
  let n;
  function a() {
    n = setTimeout(() => {
      n = void 0;
    }, 1e3);
  }
  function e(d) {
    d === "address" ? (n && (clearTimeout(n), a()), i()) : n || (n = setTimeout(() => {
      a(), i();
    }, 1e3));
  }
  window.addEventListener(o.ADDRESS_CHANGED, async () => {
    e("address");
  }), window.addEventListener(o.CHAIN_CHANGED, async () => {
    e("chain");
  }), window.addEventListener(o.PROVIDER_CHANGED, async () => {
    e("provider");
  });
}
const M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  M as p,
  r as s
};
